import { useMemo, createElement } from "react";
import classNames from "classnames";
import ColorfulMask from '../colorful-mask';
import './index.scss';
const ColorfulPopup = function ColorfulPopup({ visible, mask, onMaskClick = () => { }, position, className, maskClassName, bodyClassName, minWidth = 240, minHeight = 60, radius, onClick, children, ...otherProps }) {
    const _otherProps = otherProps || {};
    const bodyCls = classNames('au-popup-body', `au-popup-body-position-${position}`, `${mask ? '' : 'no-mask'}`, `${bodyClassName}`, `${radius ? 'radius' : ''}`);
    const percent = useMemo(() => {
        return visible ? 0 : 100;
    }, [visible]);
    const sytles = {
        minWidth,
        minHeight,
    };
    const handleTranslate = () => {
        if (position === 'bottom') {
            return `translate(0, ${percent}%)`;
        }
        if (position === 'top') {
            return `translate(0, -${percent}%)`;
        }
        if (position === 'left') {
            return `translate(-${percent}%, 0)`;
        }
        if (position === 'right') {
            return `translate(${percent}%, 0)`;
        }
        if (position === 'center') {
            return `translateY(-50%)`;
        }
        return 'none';
    };
    sytles.transform = handleTranslate();
    const content = (createElement("div", { className: bodyCls, style: sytles, onClick: onClick }, children));
    return (createElement("div", { className: `au-popup ${className}`, ..._otherProps }, mask ? (createElement(ColorfulMask, { maskClassName: maskClassName, visible: visible, onMaskClick: onMaskClick }, content)) : content));
};
ColorfulPopup.displayName = 'ColorfulPopup';
export default ColorfulPopup;
